module.exports = __webpack_public_path__ + "static/media/ChillWARE1_FAKE.b02e4045.png";